import axios from "axios";
import { server } from "./service/server/axios";

const requets = (token) => {
  const axiosInstance = axios.create({
    baseURL: server(),
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  });

  const req = {
    get: async (url, params) => await axiosInstance.get(url, { params }),
    post: async (url, data, config) => await axiosInstance.post(url, data, config),
    put: async (url, data, option) => await axiosInstance.put(url, data, option),
    patch: async (url, data, option) => await axiosInstance.patch(url, data, option),
    delete: async (url) => await axiosInstance.delete(url),
    postFile: async (url, data, option) => await axiosInstance.post(url, data, option),
  };

  return req;
};

export default requets;
